import 'imagesloaded';
import '~/lib/slick-slider-custom/slick';
import '~/lib/slick-slider-custom/slick.css';
import '~/lib/slick-slider-custom/slick-theme-custom.css';

import Modal from "bootstrap/js/src/modal";
import Cookies from "js-cookie";

import $ from '@/bundles/jquery';
import FileExplorer from "@/shared/3d-models/file-explorer";
import FollowButton from "@/shared/3d-models/follow-button-deprecated";
import HireButton from "@/shared/3d-models/hire-button";
import ImageLoader from "@/shared/3d-models/image-loader";
import LikeButton from "@/shared/3d-models/like-button";
import markdownToHtml from "@/shared/3d-models/markdown";
import urlGenerator from "@/shared/3d-models/url-generator";
import authPopupHandler from "@/shared/auth-popup-handler";
import redirect from "@/shared/redirect";
import SubmitLoading from "@/shared/submit-loading";
import Toolbox from "@/shared/toolbox";

class ModelView {
    constructor(
        modelData,
        modelId,
        folderId,
        baseUrl,
        modelName,
        fileExplorerElement,
        descriptionElement,
        galleryElement,
        commentManager,
        adminActionsContainer,
        btnLikeElement,
        btnFollowElement,
        btnHireElement,
        btnEmbedElement,
        sectionSimilarWrap
    ) {
        var $btnLike = $(btnLikeElement);
        var $btnFollow = $(btnFollowElement);
        var $btnHire = $(btnHireElement);

        this.modelData = modelData;
        this.modelId = modelId;
        this.initialFolderId = folderId;
        this.baseUrl = baseUrl;
        this.modelName = modelName;
        this.fileExplorerElement = fileExplorerElement;
        this.descriptionElement = descriptionElement;
        this.galleryElement = galleryElement;
        this.commentManager = commentManager;
        this.adminActionsContainer = adminActionsContainer;
        this.btnLike = new LikeButton($btnLike, $btnLike.hasClass('active'));
        this.btnFollow = new FollowButton($btnFollow);
        this.btnHire = new HireButton($btnHire);
        this.btnEmbedElement = btnEmbedElement;
        this.sectionSimilarWrap = sectionSimilarWrap;

        this.init();
    }

    init() {
        var self = this;

        var $description = $(self.descriptionElement);
        var markdownText = $description.text();

        var html = markdownToHtml(markdownText);
        $description.html(html);

        this.imageLoader = new ImageLoader();

        if (typeof FileExplorer !== 'undefined' && self.fileExplorerElement) {
            self.fileExplorer = new FileExplorer(
                'view',
                self.fileExplorerElement,
                self.modelId,
                self.imageLoader,
                self.baseUrl,
                {
                    rootBreadcrumbName: self.modelName
                }
            );

            $(self.fileExplorer).on('load-viewer', function (event, $container, viewerParams) {
                self.loadViewer(viewerParams, $container);
            });

            if (self.initialFolderId) {
                self.fileExplorer.openFolder(self.initialFolderId, null);
            } else {
                self.fileExplorer.refresh();
            }
        }

        var $carousel = this.loadCarousel();

//    $('#btnLoadCarousel').on('click', function() {
//        self.loadCarousel.call(self);
//    });

        if (this.commentManager) {
            this.commentManager.init();
        }

        $(this.adminActionsContainer).find('.btn-admin-action').on('click', function () {
            var $btn = $(this);
            var action = $btn.data('action');

            switch (action) {
                case 'unpublish':
                    self.unpublish(self.modelId, $btn);
                    break;
                case 'publish':
                    self.publish(self.modelId, $btn);
                    break;
                case 'delete':
                    self.deleteModel(self.modelId, $btn);
                    break;
            }
        });

        function updateEmbedCode(viewerModelId, autoplay, byline) {
            var embedUrl = window.location.protocol + '//' + window.location.host + '/3d-models/viewer/' + viewerModelId;

            if (autoplay) {
                embedUrl += '?autoplay=1';
            }

            var $iframe = $('<iframe>', {
                //width: '640', // width and height don't work here
                //height: '480',
                src: embedUrl,
                frameborder: '0',
                allowfullscreen: "",
                mozallowfullscreen: "true",
                webkitallowfullscreen: "true",
                allow: "autoplay; fullscreen; xr-spatial-tracking",
                'xr-spatial-tracking': "",
                'execution-while-out-of-viewport': "",
                'execution-while-not-rendered': "",
                'web-share': "",
            });

            var $wrapper = $('<div>').addClass('cadcrowd-embed-wrapper');
            $wrapper.append($iframe);

            if (byline) {
                var $byline = $('<div>').css({'margin-top': '10px', 'font-size': '13px'});

                var $a1 = $('<a>', {
                        href: self.modelData['url'],
                        target: '_blank'
                    })
                        .text(self.modelData['title'])
                        .css('font-weight', 'bold')
                        .css('color', '#008489')
                ;

                var $a2 = $('<a>', {
                        href: self.modelData['author_url'],
                        target: '_blank'
                    }).text(self.modelData['author_name'])
                        .css('font-weight', 'bold')
                        .css('color', '#008489')
                ;

                var $a3 = $('<a>', {
                        href: 'https://www.cadcrowd.com/',
                        target: '_blank'
                    })
                        .text('Cad Crowd')
                        .css('font-weight', 'bold')
                        .css('color', '#008489')
                ;

                $byline.append($a1);
                $byline.append(' by ');
                $byline.append($a2);
                $byline.append(' on ');
                $byline.append($a3);

                $wrapper.append($byline);
            }

            var html = $wrapper[0].outerHTML;

            $('#embedCode').val(html);

            $iframe.wrap('<div class="iframe-wrap"></div>');
            html = $wrapper[0].outerHTML;
            $('#embedPreview').html(html);
        }

        $(this.btnEmbedElement).on('click', function () {
            var $btnEmbed = $(this);
            var $btnLoadViewer = $carousel.find('.carousel-main .slick-slide.slick-current .btn-load-viewer');
            var viewerModelId;

            // If the current slide has a 3D Model option, using it for embedding.
            if ($btnLoadViewer.length > 0) {
                var viewerData = $btnLoadViewer.data('viewer');
                viewerModelId = viewerData['id'];
            } else {
                viewerModelId = $btnEmbed.data('viewer-model');
            }

            var $modal = $('#embedModal');
            var $inputCode = $('#embedCode');
            var $inputAutoplay = $('#embedOptionAutoplay');
            var $inputByline = $('#embedOptionByline');
            var $btnCopy = $modal.find('.btn-copy');
            var originalCopyButtonHtml = $btnCopy.html();

            updateEmbedCode(viewerModelId, false, true);
            new Modal($modal, {}).show();

            $btnCopy.off('click').on('click', function () {
                /* Select the text field */
                $inputCode[0].select();
                $inputCode[0].setSelectionRange(0, 99999); /* For mobile devices */

                /* Copy the text inside the text field */
                document.execCommand("copy");

                $btnCopy.html('<i class="fas fa-check"></i> Copied');
            });

            $modal.on('hidden.bs.modal', function () {
                $btnCopy.html(originalCopyButtonHtml);
            });

            $inputAutoplay.off('change').on('change', function () {
                updateEmbedCode(viewerModelId, $inputAutoplay.is(':checked'), $inputByline.is(':checked'));
            });

            $inputByline.off('change').on('change', function () {
                updateEmbedCode(viewerModelId, $inputAutoplay.is(':checked'), $inputByline.is(':checked'));
            });
        });

        var galleryUrl = Cookies.get('cad_models_url');

        if (galleryUrl) {
            $('#breadcrumbs > li:first > a').attr('href', galleryUrl);
        }

        this.loadModelInfo();
        this.loadSimilarModels();

        $.ajax('/api/v1/3d-models/' + self.modelId + '/log', {
            method: 'POST',
        });
    }

    loadModelInfo() {
        var self = this;

        $.ajax('/api/v1/3d-models/' + this.modelId + '/info', {
            method: 'GET',
        }).then(function (response) {
            self.populateSkeletons(response);

            if (response.show_contact_buttons || self.btnFollow.actsAsLoginButton()) {
                self.btnFollow.enable();
            } else {
                self.btnFollow.disable();
            }

            if (response.is_followed) {
                self.btnFollow.makeActive();
            } else {
                self.btnFollow.makeInactive();
            }

            if (response.show_hire_button) {
                self.btnHire.enable();
            } else {
                self.btnHire.disable();
            }

            self.btnLike.init(response.is_liked);
        });
    }

    populateSkeletons(data) {
        var getStatsHtml = function(n, form1, form2)
        {
            var $container = $('<div>');
            $container.append($('<span>').addClass('num').attr('data-num', n).text(n.format()));
            $container.append(' ');
            $container.append($('<span>').addClass('text').text(n === 1 ? form1 : form2));
            return $container.html();
        }

        var getReviewsHtml = function(reviewScore, numReviews, form1, form2)
        {
            var $container = $('<div>');
            if (reviewScore > 0) {
                $container.append($('<span>').addClass('num').attr('data-num', reviewScore).text(reviewScore.format()));
                $container.append(' ');
            }
            $container.append($('<span>').addClass('text small').text('(' + numReviews.format() + ' ' + (numReviews === 1 ? form1 : form2) + ')'));
            return $container.html();
        }

        $('#skeletonViews').html(getStatsHtml(data.num_views, 'view', 'views'));
        $('#skeletonComments').html(getStatsHtml(data.num_comments, 'comment', 'comments'));
        $('#skeletonDownloads').html(getStatsHtml(data.num_downloads, 'download', 'downloads'));
        $('#skeletonReviews').find('.line').replaceWith(getReviewsHtml(data.review_score, data.num_reviews, 'review', 'reviews'));
        $('#btnLike').find('.line').replaceWith(getStatsHtml(data.num_likes, 'like', 'likes'));

        var $sectionLikedUsers = $('.liked-row.skeleton');

        if (data.liked_users.length > 0) {
            var $likedUsersUl = $sectionLikedUsers.find('ul');
            $likedUsersUl.empty();

            data.liked_users.forEach(function (userData) {
                var $a = $('<a>', {
                    href: userData.link,
                    target: '_blank',
                });

                var $img = $('<img>', {
                    src: userData.avatar_url,
                    alt: userData.display_name,
                    title: userData.display_name,
                    width: 32,
                    height: 32,
                }).addClass('rounded-circle user-avatar');

                $a.append($img);
                $likedUsersUl.append($('<li>').append($a));
            });

            var othersCount = data.num_likes - data.liked_users.length;
            var text = othersCount > 0 ? ('+ ' + othersCount.format() + ' others ') : '';
            text += 'liked this model';
            $sectionLikedUsers.find('.skeleton-liked-text').replaceWith(text);
        } else {
            $sectionLikedUsers.remove();
        }
    }

    loadSimilarModels() {
        var self = this;

        if (!self.sectionSimilarWrap) {
            return;
        }

        $.ajax('/3d-models/' + this.modelId + '/similar', {
            method: 'GET',
        }).then(function (response) {
            $(self.sectionSimilarWrap).html(response);
        });
    }

    loadCarousel() {
        console.debug('Loading carousel...');

        var self = this;

        var $gallery = $(this.galleryElement);
        var $carouselMain = $gallery.find('.carousel-main');
        var $carouselNav = $gallery.find('.carousel-nav');

        $gallery.imagesLoaded().always(function () {
            console.debug('Images loaded!');

            $gallery.removeClass('loading');
            $gallery.find('.loader-ellips').remove();

            $carouselMain.slick({
                rows: 0,
                adaptiveHeight: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                initialSlide: 0,
                //mobileFirst: true,
                infinite: false,
                //asNavFor: '#carouselNav',
                variableWidth: true,
                centerMode: true,
                centerPadding: false,
                focusOnSelect: true,
                prevArrow: '<button type="button" class="slick-prev"><i class="fas fa-chevron-left"></i></button>',
                nextArrow: '<button type="button" class="slick-next"><i class="fas fa-chevron-right"></i></button>',
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            arrows: false,
                            centerMode: true,
                            centerPadding: '40px',
                            slidesToShow: 1
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            arrows: false,
                            centerMode: true,
                            centerPadding: '40px',
                            slidesToShow: 1
                        }
                    }
                ]
            });

            $carouselNav.slick({
                rows: 0,
                slidesToShow: 5,
                slidesToScroll: 5,
                infinite: false,
                asNavFor: '#carouselMain',
                centerMode: false,
                centerPadding: false,
                prevArrow: '<button type="button" class="slick-prev"><i class="fas fa-chevron-left"></i></button>',
                nextArrow: '<button type="button" class="slick-next"><i class="fas fa-chevron-right"></i></button>'
            });

            $carouselMain.on("afterChange", function (e, slick, index) {
                var $slide = $carouselNav.find('.slick-slide[data-slick-index="' + index + '"]');

                if (!$slide.hasClass('slick-active')) {
                    $carouselNav.slick('slickGoTo', index);
                }

                $slide.addClass('selected').siblings('.slick-slide').removeClass('selected');
            });

            $carouselNav.find('.slick-slide').on('click', function () {
                console.debug('clicked on nav slide', $(this).data('slickIndex'), this);

                $carouselMain.slick('slickGoTo', $(this).data('slickIndex'));
            });

            var currentSlideIndex = $carouselNav.slick('slickCurrentSlide');
            var $slide = $carouselNav.find('.slick-slide[data-slick-index="' + currentSlideIndex + '"]');
            $slide.addClass('selected').siblings('.slick-slide').removeClass('selected');

            $gallery.on('click', '.btn-load-viewer', function () {
                var $btn = $(this);
                var viewerParams = $(this).data('viewer');

                SubmitLoading.startLoading($btn);

                var $container = $btn.parent();
                var $image = $container.find('.image-content');

                self.loadViewer(viewerParams, $container, $image.width(), $image.height());
            });
        });

        return $gallery;
    }

    loadViewer(viewerData, $container, width, height) {
        width = (width || $container.width());
        height = (height || $container.height());

        var $iframeWrap = $('<div>').addClass('model-viewer-wrap');

        var $loaderWrap = $('<div>').addClass('model-viewer-loader-wrap');
        $loaderWrap.html('<div class="loader-ellips loader-ellips-light"><div class="loader-ellips-dot"></div><div class="loader-ellips-dot"></div><div class="loader-ellips-dot"></div></div>');

        var $iframe = $('<iframe>', {
            width: width,
            height: height,
            src: '/3d-models/viewer/' + viewerData['id'] + '?autoplay=1',
            frameborder: '0',
            allow: 'autoplay; fullscreen; vr',
            mozallowfullscreen: 'true',
            webkitallowfullscreen: 'true'
        });

        $iframeWrap.append($loaderWrap);
        $iframeWrap.append($iframe);

        $container.empty().append($iframeWrap);
    }

    unpublish(modelId, $btn) {
        var url = urlGenerator.unpublish(modelId);

        Toolbox.confirm(
            'Unpublish',
            'Are you sure you want to unpublish your 3D model?',
            function () {
                SubmitLoading.startLoading($btn);

                $.ajaxCsrf(url, {
                    method: 'POST'
                }).done(function (data) {
                    if (data.error) {
                        if (data.error === 'auth_required') {
                            authPopupHandler.showLoginPopup();
                        }

                        Toolbox.error(data.data.message);
                    }

                    if (typeof data.unpublished !== 'undefined') {
                        Toolbox.success('The model has been unpublished.');

                        window.setTimeout(function () {
                            redirect(urlGenerator.viewMyList());
                        }, 1000);
                    }
                }).fail(function () {
                    Toolbox.error('Error unpublishing the model.');
                }).always(function () {
                    SubmitLoading.finishLoading($btn);
                });
            },
            function () {
            },
            {
                ok: 'Unpublish',
                cancel: 'Cancel'
            }
        );
    }

    publish(modelId, $btn) {
        var url = urlGenerator.publish(modelId);

        SubmitLoading.startLoading($btn);

        $.ajaxCsrf(url, {
            method: 'POST'
        }).done(function (data) {
            if (data.error) {
                if (data.error === 'auth_required') {
                    authPopupHandler.showLoginPopup();
                }

                Toolbox.error(data.data.message);
            }

            if (typeof data.published !== 'undefined') {
                Toolbox.success('The model has been published.');

                if (data.url) {
                    window.setTimeout(function () {
                        redirect(data.url);
                    }, 1000);
                }
            }
        }).fail(function () {
            Toolbox.error('Error publishing the model.');
        }).always(function () {
            SubmitLoading.finishLoading($btn);
        });
    }

    deleteModel(modelId, $btn) {
        var url = urlGenerator.deleteModel(modelId);

        Toolbox.confirm(
            'Delete Model',
            'Are you sure you want to delete your 3D model? This cannot be undone.',
            function () {
                $btn.prop('disabled', true);

                $.ajaxCsrf(url, {
                    method: 'POST'
                }).done(function (data) {
                    if (data.error) {
                        if (data.error === 'auth_required') {
                            authPopupHandler.showLoginPopup();
                        }

                        Toolbox.error(data.data.message);
                    }

                    if (typeof data.deleted !== 'undefined') {
                        Toolbox.success('The model has been deleted.');

                        window.setTimeout(function () {
                            redirect(urlGenerator.viewMyList());
                        }, 1000);
                    }
                }).fail(function () {
                    Toolbox.error('Error deleting the model.');
                }).always(function () {
                    $btn.prop('disabled', false);
                });
            },
            function () {
            },
            {
                ok: 'Delete',
                cancel: 'Cancel'
            }
        );
    }
}

export default ModelView;
